import { Outlet, useLoaderData, useNavigate } from "react-router-dom";
import useStore from "../../../../hooks/useStore";
import Error from "../../../../pages/Error";
import { useEffect, useState } from "react";
import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin } from 'antd';
import { postExchangeAuthorizationCode } from "../../../apiRepository/Ubereats";

export async function loader({ request }) {
  const url = new URL(request.url);
  const code = url.searchParams.get("code");
  const provisionType = url.searchParams.get("provision_type");
  const token = sessionStorage.getItem("token");

  if (!code || !provisionType) {
    throw new Response("", {
      status: 404,
      statusText: "Page not found.",
    });
  }

  return { code, provisionType, token };
}

export default function UberEatsProvisioning() {
  const { code, provisionType, token } = useLoaderData();
  const { setStore } = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const integratorId = sessionStorage.getItem("integratorId");
  const storeId = sessionStorage.getItem("storeId");
  const navigate = useNavigate();

  useEffect(() => {
    const postCode = async () => {
      try {
        const ubereats = await postExchangeAuthorizationCode({
          integratorId: integratorId,
          storeId: storeId,
          redirectUri: `${process.env.REACT_APP_UBER_REDIRECT_URI}?provision_type=${provisionType}`,
          authorizationCode: code,
          token: token
        });

        sessionStorage.setItem("ubereatsCode", code);
        sessionStorage.setItem("ubereatsProvisionType", provisionType);
        sessionStorage.setItem("ubereatsAccessToken", ubereats?.accessToken);
        sessionStorage.setItem(
          "ubereatsStores",
          JSON.stringify(ubereats?.stores),
        );

        setStore({
          ubereatsAccessToken: ubereats?.accessToken,
          ubereatsStores: ubereats?.stores,
          ubereatsCode: code,
          ubereatsProvisionType: provisionType,
        });

        navigate(
          `/ubereats/${provisionType === "add" ? "provision" : "deprovision"}`,
          {
            replace: true,
          },
        );
      } catch (err) {
        navigate(
          `/ubereats/${provisionType === "add" ? "provision" : "deprovision"}}`,
          {
            replace: true,
          },
        );
      } finally {
        setIsLoading(false);
      }
    };

    code && storeId && postCode();
  }, [code, storeId, navigate, provisionType, setStore]);

  if (!storeId) {
    return <Error />;
  }

  if (isLoading)
    return (
      <Flex
        justify="center"
        align="center"
        style={{ height: '100vh' }}
      >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />} />
      </Flex>
    );

  return <Outlet />;
}
